import $ from 'jquery';

const filter = (county, $brokerOfficeListings) => {
  const hideCards = $brokerOfficeListings.find('.card[data-county!="' + $(county).text() + '"]');
  const showCards = $brokerOfficeListings.find('.card[data-county="' + $(county).text() + '"]');

  if (showCards.length === 0) {
    hideCards.css('display', '');
  } else {
    $(hideCards).hide();
    showCards.css('display', '');
  }
};

const createDropdownChoices = ($brokerOfficeListings) => {
  const cards = $brokerOfficeListings.find('.card');

  const counties = {};

  for (let i = 0; i < cards.length; i++) {
    const attr = cards[i].getAttribute('data-county');

    if (counties[attr] !== undefined) {
      counties[attr]++;
    } else {
      counties[attr] = 1;
    }
  }
  return counties;
};

const populateDropdownList = (counties, $brokerOfficeListingDropdown) => {
  const outerList = $brokerOfficeListingDropdown.find('ul');

  const keys = Object.keys(counties).sort();

  for (let i = 0; i < keys.length; i++) {
    outerList.append('<li><a href="#"><span>' + keys[i] + '</span> (' + counties[keys[i]] + ')</li>');
  }
};

const initPage = (brokerOfficeListId) => {
  const $brokerOfficeListings = $('#list-' + brokerOfficeListId);
  const $brokerOfficeListingDropdown = $('#dropdown-' + brokerOfficeListId);

  const choiceList = createDropdownChoices($brokerOfficeListings);
  populateDropdownList(choiceList, $brokerOfficeListingDropdown);

  $brokerOfficeListingDropdown.find('a').click((event) => {
    event.preventDefault();
    $('.dropdown .choice').html(event.currentTarget.innerHTML);
    filter(event.currentTarget.innerHTML, $brokerOfficeListings);
  });
};

export { initPage };
